import { render, staticRenderFns } from "./StudentStatusCard.vue?vue&type=template&id=671900be&scoped=true&"
import script from "./StudentStatusCard.vue?vue&type=script&lang=ts&"
export * from "./StudentStatusCard.vue?vue&type=script&lang=ts&"
import style0 from "./StudentStatusCard.vue?vue&type=style&index=0&id=671900be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671900be",
  null
  
)

export default component.exports